import { useState } from 'react';

import type { TaxedMoney } from '@/graphql/saleor/api';
import type { ProductTypeOptions } from '@/lib/product';

export type Product = {
  id: string;
  objectID?: string | null | undefined;
  price: TaxedMoney;
  productTypeSlug: ProductTypeOptions;
  sku: string | null | undefined;
};
export interface AllSelectedProducts {
  products: Product[];
  totalPrice: TaxedMoney;
}

export const useAllSelectedProductsState = (
  initialState: AllSelectedProducts,
) => {
  const [allSelectedProducts, setAllSelectedProducts] =
    useState<AllSelectedProducts>(initialState);
  return { allSelectedProducts, setAllSelectedProducts };
};
